// small multiselect element used in the header of the edit form on candidates
// recommendation for manual JPAs, a duplicate of the multiselect element in the
// ShareElements directory, with additional props.

// Additional PROPS:
// PreSelectedOptions: the options that have already been selected
// IsWorkCity: a boolean determining wether the item is workCity (different in type, it is a string with commas)

import React, { useState, useEffect, useCallback } from "react";
import "../../../../../../Assets/Styles/Select.scss";

const MultiSelect = (props) => {
  const [IsOpen, setIsOpen] = useState(true);
  const [SelectedItems, setSelectedItems] = useState([]);
  const [ListLength, setLisLength] = useState(0);
  const [PreselectedOptions, setPreSelectedOptions] = useState([]); // only used when props.IsWorkcity is true
  const [SelectedCount, setSelectedCount] = useState();
  useEffect(() => {
    if (props.IsWorkCity) {
      convertCommaSeparatedToArray();
    } else {
      handlePreSelectedOptions();
    }
  }, [props.Name]);

  const handlePreSelectedOptions = () => {
    let OptNames = [];
    props.PreSelectedOptions?.map((Opt) => {
      OptNames.push(Opt.name);
    });
    setPreSelectedOptions(OptNames);
    setSelectedCount(OptNames.length);
  };

  const convertCommaSeparatedToArray = () => {
    var OptNames;
    // make sure the value exist
    if (props.PreSelectedOptions !== null && Boolean(props.PreSelectedOptions)) {
      OptNames = props.PreSelectedOptions.split(",");
    } else {
      OptNames = [];
    }
    setPreSelectedOptions(OptNames);
    setSelectedCount(OptNames.length);
  };

  const handleDropDown = () => {
    setIsOpen(!IsOpen);
    if (IsOpen) {
      document
        .getElementById(props.Id + "-select")
        .classList.add("select-dropdown-is-open");
      document.getElementById(props.Id + "-select").click();
    } else {
      document
        .getElementById(props.Id + "-select")
        .classList.remove("select-dropdown-is-open");
    }
  };
  const selectItem = (Option) => {
    var ClassList;
    if (props.IsWithId) {
      ClassList = document.getElementById("icon-" + Option.id).classList;
    } else {
      ClassList = document.getElementById("icon-" + Option).classList;
    }
    if (ClassList.length == 1) {
      if (props.IsWithId) {
        document
          .getElementById("icon-" + Option.id)
          .classList.add("feather-check-selected");
        addToSelectedItems(Option.id);
      } else {
        document
          .getElementById("icon-" + Option)
          .classList.add("feather-check-selected");
        addToSelectedItems(Option);
      }
    } else {
      if (props.IsWithId) {
        document
          .getElementById("icon-" + Option.id)
          .classList.remove("feather-check-selected");
        deleteFromSelectedItems(Option.id);
      } else {
        document
          .getElementById("icon-" + Option)
          .classList.remove("feather-check-selected");
        deleteFromSelectedItems(Option);
      }
    }
    if (props.ChangeHandler) {
      props.ChangeHandler();
    }
    if (props.SaveSelectedOptions) {
      let Selected = [];
      props.Options.map((Opt) => {
        if (
          document
            .getElementById("icon-" + Opt.id)
            .classList.contains("feather-check-selected")
        ) {
          Selected.push(Opt);
        }
      });
      props.SaveSelectedOptions(Selected);
    }
    updateSelectedCount();
  };
  const updateSelectedCount = () => {
    let Count = 0;
    props.Options.map((Opt) => {
      if (
        document
          .getElementById("icon-" + Opt.id)
          .classList.contains("feather-check-selected")
      ) {
        Count++;
      }
    });
    setSelectedCount(Count);
  };
  const addToSelectedItems = useCallback(
    (Option) => {
      let ListOfItems = [...SelectedItems];
      ListOfItems.push(Option);
      setSelectedItems(ListOfItems);
      setLisLength(ListOfItems.length);
      document.getElementById(props.Id + "-filter").value = ListOfItems;
    },
    [SelectedItems]
  );
  const deleteFromSelectedItems = useCallback(
    (Option) => {
      let ListOfItems = [...SelectedItems];
      ListOfItems = ListOfItems.filter((Item) => {
        return Item !== Option;
      });
      setSelectedItems(ListOfItems);
      setLisLength(ListOfItems.length);
      document.getElementById(props.Id + "-filter").value = ListOfItems;
    },
    [SelectedItems]
  );
  const clearItems = () => {
    SelectedItems.map((Item) => {
      document
        .getElementById("icon-" + Item)
        .classList.remove("feather-check-selected");
      deleteFromSelectedItems(Item);
    });
    setSelectedItems([]);
    setLisLength(0);
    props.ChangeHandler();
  };
  return (
    <React.Fragment>
      {!IsOpen ? (
        <div
          onClick={() => handleDropDown()}
          className="select-outline-area"
        ></div>
      ) : null}
      <div className="cx-multi-select" id={props.Id + "-select"}>
        {ListLength === 0 ? (
          <button
            onClick={() => handleDropDown()}
            className="select-trigger"
          ></button>
        ) : (
          <React.Fragment>
            <button onClick={() => handleDropDown()} className="select-trigger">
              {/* <p
                className="label-text selected-count"
                id={"pre-selected-" + props.Id}
              >
                {parseInt(SelectedItems.length + PreselectedOptions.length) +
                  " Selected"}
              </p> */}
            </button>
            {/* <img
              className="clear"
              id={props.Id + "-clear"}
              onClick={() => clearItems()}
              alt="X"
              src={CloseIcon}
            /> */}
          </React.Fragment>
        )}
        <input className="hidden" id={props.Id + "-filter"} />
        {SelectedItems.length === 0 ? (
          <p className="label-text" id={"pre-selected-" + props.Id}>
            {SelectedCount + " Selected"}
          </p>
        ) : (
          <p className="label-text" id={"pre-selected-" + props.Id}>
            {SelectedCount + " Selected"}
          </p>
        )}
        <i
          className="feather-chevron-down"
          onClick={() => handleDropDown()}
        ></i>
        <section className="cx-dropdown">
          {props.Options.map((option) => (
            <div
              id={"option-" + option.id}
              className="option-item"
              onClick={() => selectItem(option)}
              key={option.id}
            >
              <span>
                <i
                  className={
                    PreselectedOptions.indexOf(option.name) === -1
                      ? "feather-check"
                      : "feather-check feather-check-selected"
                  }
                  id={"icon-" + option.id}
                ></i>
              </span>
              <p>{option.name}</p>
            </div>
          ))}
        </section>
        <p className="select-validation-message">{props.ValidationError}</p>
      </div>
    </React.Fragment>
  );
};

export default MultiSelect;
